// reducers/ToggleSound.js

import { TOGGLE_SOUND } from "../actions/types";

/**
 * Reducer for toggling the sound setting (on/off).
 * @param {boolean} state - Current sound state (default: false).
 * @param {Object} action - Redux action.
 * @returns {boolean} The updated sound state.
 */
const initialState = false;

const soundToggleReducer = (state = initialState, action) => {
  if (action.type === TOGGLE_SOUND) {
    // Toggles the sound setting (true <-> false)
    return !state;
  }
  // Returns the current state for any unrelated action
  return state;
};

export default soundToggleReducer;
